export default __webpack_public_path__ + "static/media/img_selected-industry-retail.7a094e78.svg";